// ExampleModal.tsx
import React from "react";
import { Close } from "@mui/icons-material";

interface ExampleModalProps {
    title: string;
    imageSrc: string;
    open: boolean;
    onClose: () => void;
}

export const ExampleModal: React.FC<ExampleModalProps> = ({
    title,
    imageSrc,
    open,
    onClose,
}) => {
    if (!open) return null;

    return (
        <div className="example-backdrop" onClick={onClose}>
            <div className="example-content" onClick={(e) => e.stopPropagation()}>
                <div className="example-header">
                    <button
                        className="closeExample"
                        type="button"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <Close />
                    </button>
                </div>
                <div className="example-body">
                    {title && <h5 className="example-title">{title}</h5>}
                    <img src={imageSrc} alt="Example" />
                </div>
            </div>
        </div>
    );
};